import { Address } from "./address";

export class CompanyInfo {
  private address: Address;
  private employeeCount: number;

  getAddress(): Address {
    return this.address;
  }

  setAddress(address: Address): void {
    this.address = address;
  }

  getEmployeeCount(): number {
    return this.employeeCount;
  }

  setEmployeeCount(employeeCount: number): void {
    this.employeeCount = employeeCount;
  }
}
